var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('b-button',{staticClass:"my-1",attrs:{"id":"download-button","md":"6","variant":"primary"},on:{"click":_vm.downloadData}},[_vm._v("Download Data")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }